export default __webpack_public_path__ + "static/media/IMG_7468 copie copy.a8abf261.jpg";